import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';

import SahamDrawer from 'components/SahamDrawer';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/messages';
import procedureInformationMessages from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/messages';
import { translate } from 'containers/services/translate';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { ProcedureInfoWrapper } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/styled-components';
import ProcedureInformationForm from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/index';
import { Listings } from 'containers/AppContainer/typings';
import * as validateForm from 'containers/services/validateForm';
import { detailsValidator } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/form-validation';
import { FIELDS_TO_UPDATE } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/constants';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { validationCourtFileNumber } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';

export interface ProcedureInformationDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  details: Idetails;
  setDetails: Function;
  listings: Listings;
  setJudgementAdd: Function;
  vehicules: Vehicule[];
  lossDate: string;
  sagisOpposingParties: any;
  currentJudiciaryProcess: any;
}

const ProcedureInformationDrawer: React.FC<ProcedureInformationDrawerProps> = ({
  listings,
  details,
  setDetails,
  ...props
}): JSX.Element => {
  const [canSave, setCanSave] = useState<boolean>(false);

  useEffect(() => {
    const isFormValidated = validateForm.validateFormFields(
      detailsValidator(details),
    );
    setCanSave(isFormValidated);
  }, [details]);

  const handleSaveDetails = () => {
    props.setJudgementAdd(FIELDS_TO_UPDATE.DETAILS, details);
    props.handleToggleDrawer();
  };

  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate(
        procedureInformationMessages.procedureInformationTitle,
        props,
      )}
      confirmButtonTitle={translate(messages.save, props)}
      isSaveButtonDisabled={
        !canSave || !validationCourtFileNumber(details.courtFile)
      }
      handleValidateDrawer={handleSaveDetails}
    >
      <ProcedureInfoWrapper>
        <ProcedureInformationForm
          isDrawer
          details={details}
          setDetails={setDetails}
          listings={listings}
          shouldDisplay={false}
          vehicules={props.vehicules}
          lossDate={props.lossDate}
          sagisOpposingParties={props.sagisOpposingParties}
          currentJudiciaryProcess={props.currentJudiciaryProcess}
        />
      </ProcedureInfoWrapper>
    </SahamDrawer>
  );
};

export default injectIntl(ProcedureInformationDrawer);
